module.exports = __webpack_public_path__ + "img/mp-img-9.a42e9b86.jpg";